/**
 * Maps storefront-layout dataLayer analytics to @template-project/storefront-funnel FunnelAnalytics.
 */

import type { FunnelAnalytics } from '@template-project/storefront-funnel';
import {
  trackFunnelExperienceShown,
  trackFunnelOfferAccepted,
  trackFunnelOfferDeclined,
  trackFunnelAddToCart,
  trackFunnelPopupShown,
  trackFunnelLeadsSubmitted,
  trackFunnelExperienceDismissed,
} from './analytics';

export const layoutFunnelAnalytics: FunnelAnalytics = {
  trackExperienceShown: (params) =>
    trackFunnelExperienceShown({
      funnelId: params.funnelId,
      stepId: params.stepId,
      stepName: params.stepName,
      experienceType: params.experienceType,
      placement: params.placement,
    }),
  trackOfferAccepted: (params) =>
    trackFunnelOfferAccepted({
      funnelId: params.funnelId,
      stepId: params.stepId,
      offerId: params.offerId,
      offerName: params.offerName,
      productId: params.productId,
    }),
  trackOfferDeclined: (params) =>
    trackFunnelOfferDeclined({
      funnelId: params.funnelId,
      stepId: params.stepId,
      offerId: params.offerId,
    }),
  trackAddToCart: (params) => trackFunnelAddToCart(params),
  trackPopupShown: (params) => trackFunnelPopupShown(params),
  trackLeadsSubmitted: (params) => trackFunnelLeadsSubmitted(params),
  trackExperienceDismissed: (params) =>
    trackFunnelExperienceDismissed({
      funnelId: params.funnelId,
      stepId: params.stepId,
    }),
};
